import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { Button } from '@/components/ui';
import { isStaleChunkError, reloadOnceForStaleChunk } from '@/lib/lazy-page';

/**
 * errorElement global del router. Si el error es un chunk viejo tras un
 * deploy, recarga la página automáticamente (una sola vez); para el resto
 * muestra un mensaje amable en lugar de la pantalla por defecto de React
 * Router ("Unexpected Application Error!").
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const isStale = isStaleChunkError(error);

  useEffect(() => {
    if (isStale) {
      reloadOnceForStaleChunk();
    } else {
      console.error('[RouteErrorPage]', error);
    }
  }, [isStale, error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="space-y-2">
          <h1 className="font-display text-2xl text-foreground">
            {isStale ? 'Nueva versión disponible' : 'Algo salió mal'}
          </h1>
          <p className="text-[13px] text-muted-foreground">
            {isStale
              ? 'Actualizamos la aplicación mientras tenías esta pestaña abierta. Recarga para continuar con la última versión.'
              : 'Ocurrió un error inesperado al cargar esta sección. Recarga la página para intentarlo de nuevo.'}
          </p>
        </div>
        <div className="flex items-center justify-center gap-3">
          <Button variant="primary" onClick={() => window.location.reload()}>
            Recargar página
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            Ir al inicio
          </Button>
        </div>
      </div>
    </div>
  );
}
